import React from 'react';

import { formatValueToLocale } from '../../../shared/utilities';
import setStateAsync from '../../../../../../common/edlio-js/utils/setStateAsync';
import Localization from "../../../../../../common/edlio-js/models/BackendLocalization";

export default class InputCost extends React.Component {
	constructor(props) {
		super(props);

		this.state = { value: props.cost }
	}

	componentDidUpdate(prevProps) {
		const { cost } = this.props;

		if (cost !== prevProps.cost) {
			this.setState({ value: cost });
		}
	}

	handleKeyPress(e) {
		const invalidChars = ["-", "+", "e"];

		if (invalidChars.includes(e.key)) {
			e.preventDefault();
			e.stopPropagation();
		}
	}

	handleChange(e) {
		const newValue = e.target.value;

		if (newValue < 0) {
			alert("Value cannot be negative.");

			return;
		}

		this.setState({ value: newValue });
	}

	async handleBlur(e) {
		const { onMinChange, onMaxChange, updateCost } = this.props;

		const unformatted = e.target.value !== "" || onMaxChange ? e.target.value : "0";

		let formatted = parseFloat(unformatted).toFixed(2);

		if (isNaN(formatted)) { formatted = ""; }

		e.target.value = formatted;

		await setStateAsync({ value: formatted }, this)

		if(onMaxChange) {
			onMaxChange(formatted);
		} else if (onMinChange) {
			onMinChange(formatted);
		} else if (updateCost) {
			updateCost(formatted);
		}
	}

	render() {
		const { required, cost, includeLabel: includeLabelProp, onMaxChange } = this.props;
		let localization = new Localization(window.edlio.localizations);

		const includeLabel = (includeLabelProp === true || includeLabelProp === false) ? includeLabelProp : true;
		const placeholder = onMaxChange ? localization.localize('any') : '0.00';

		return (
			<div className='cost'>
				{includeLabel &&
					<label>
						<span className='currency-symbol'>$</span>

						{formatValueToLocale(cost)}

						{required &&
							<em className='required-indicator'>*</em>
						}
					</label>
				}

				<div className='currency-container'>
					<span className='currency-symbol'>$</span>

					<input
						ref='input'
						type='number'
						value={this.state.value}
						placeholder={placeholder}
						min={0}
						onKeyPress={this.handleKeyPress.bind(this)}
						onChange={this.handleChange.bind(this)}
						onBlur={this.handleBlur.bind(this)}
					/>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/widgets/input-cost.js